import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "data-panel" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"#9ca3af","font-size":"14px"}
}
const _hoisted_3 = { class: "data-settings" }
const _hoisted_4 = { class: "data-field" }
const _hoisted_5 = { class: "data-field" }
const _hoisted_6 = { style: {"display":"flex","gap":"8px","align-items":"center"} }
const _hoisted_7 = { class: "data-field" }
const _hoisted_8 = { style: {"display":"flex","gap":"8px","align-items":"center"} }
const _hoisted_9 = { class: "data-field" }
const _hoisted_10 = {
  key: 0,
  class: "data-field"
}
const _hoisted_11 = {
  key: 1,
  class: "data-error"
}
const _hoisted_12 = {
  key: 2,
  class: "data-success"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "data-settings" }
const _hoisted_15 = { class: "data-field" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "data-field" }
const _hoisted_18 = {
  key: 0,
  class: "data-error"
}
const _hoisted_19 = {
  key: 1,
  class: "data-success"
}
const _hoisted_20 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$setup.detail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Carregando..."))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "data-title" }, "Configurações da Obra", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[11] || (_cache[11] = _createElementVNode("label", null, "Nome da obra", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.configSiteName) = $event)),
                type: "text",
                placeholder: "Nome da obra"
              }, null, 512), [
                [_vModelText, $setup.configSiteName]
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[12] || (_cache[12] = _createElementVNode("label", null, "Cor primária", -1)),
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.configPrimaryColor) = $event)),
                  type: "color",
                  style: {"width":"40px","height":"36px","border":"none","cursor":"pointer","background":"none"}
                }, null, 512), [
                  [_vModelText, $setup.configPrimaryColor]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.configPrimaryColor) = $event)),
                  type: "text",
                  placeholder: "#0f4c81",
                  style: {"flex":"1"}
                }, null, 512), [
                  [_vModelText, $setup.configPrimaryColor]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[13] || (_cache[13] = _createElementVNode("label", null, "Cor secundária", -1)),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.configSecondaryColor) = $event)),
                  type: "color",
                  style: {"width":"40px","height":"36px","border":"none","cursor":"pointer","background":"none"}
                }, null, 512), [
                  [_vModelText, $setup.configSecondaryColor]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.configSecondaryColor) = $event)),
                  type: "text",
                  placeholder: "#e8f0f7",
                  style: {"flex":"1"}
                }, null, 512), [
                  [_vModelText, $setup.configSecondaryColor]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[15] || (_cache[15] = _createElementVNode("label", null, "Logotipo da navbar", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.configLogoType) = $event)),
                style: {"width":"100%","padding":"8px","border":"1px solid #ddd","border-radius":"4px"}
              }, [...(_cache[14] || (_cache[14] = [
                _createElementVNode("option", { value: "default" }, "ObraTycoon by GusMachado", -1),
                _createElementVNode("option", { value: "by-gus" }, "by GusMachado", -1),
                _createElementVNode("option", { value: "custom" }, "Personalizado", -1)
              ]))], 512), [
                [_vModelSelect, $setup.configLogoType]
              ])
            ]),
            ($setup.configLogoType === 'custom')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", null, "Texto personalizado", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.configCustomLogoText) = $event)),
                    type: "text",
                    placeholder: "Digite o texto que deseja exibir"
                  }, null, 512), [
                    [_vModelText, $setup.configCustomLogoText]
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.configError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString($setup.configError), 1))
              : _createCommentVNode("", true),
            ($setup.configSuccess)
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString($setup.configSuccess), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn-admin-primary",
              type: "button",
              disabled: $setup.configSaving,
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.saveConfig && $setup.saveConfig(...args)))
            }, _toDisplayString($setup.configSaving ? 'Salvando...' : 'Salvar'), 9, _hoisted_13)
          ]),
          _cache[21] || (_cache[21] = _createElementVNode("hr", { class: "data-sep" }, null, -1)),
          _cache[22] || (_cache[22] = _createElementVNode("h3", { class: "data-title" }, "Alterar senha de usuário", -1)),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _cache[18] || (_cache[18] = _createElementVNode("label", null, "Usuário", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.pwdUsername) = $event)),
                class: "data-select"
              }, [
                _cache[17] || (_cache[17] = _createElementVNode("option", { value: "" }, "Selecione um usuário", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.detail.users, (u) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: u.username,
                    value: u.username
                  }, _toDisplayString(u.name) + " (" + _toDisplayString(u.username) + ")", 9, _hoisted_16))
                }), 128))
              ], 512), [
                [_vModelSelect, $setup.pwdUsername]
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[19] || (_cache[19] = _createElementVNode("label", null, "Nova senha", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.pwdNew) = $event)),
                type: "password",
                placeholder: "Nova senha"
              }, null, 512), [
                [_vModelText, $setup.pwdNew]
              ])
            ]),
            ($setup.pwdError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString($setup.pwdError), 1))
              : _createCommentVNode("", true),
            ($setup.pwdSuccess)
              ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString($setup.pwdSuccess), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn-admin-primary",
              type: "button",
              disabled: $setup.pwdSaving,
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => ($setup.saveUserPassword && $setup.saveUserPassword(...args)))
            }, _toDisplayString($setup.pwdSaving ? 'Salvando...' : 'Alterar senha'), 9, _hoisted_20)
          ])
        ], 64))
  ]))
}